//Material-UI
import ProtectedRoute from './../components/util/ProtectedRoute/ProtectedRoute';
import NotFoundPage from './../components/util/ProtectedRoute/NotFoundPage';
import {
  Routes,
  Route,
  Outlet
} from "react-router-dom";

import React from 'react';

import { isUser, isStudent } from './../app/util';

import { useSelector } from 'react-redux';

// Home
import Home from './Home/Home';

// Users
import UserHome from './user/UserHome/UserHome';
import UserApplication from './user/UserApplication/UserApplication';
import UserHistory from './user/UserHistory/UserHistory';

function PageRouter() {
  const appState = useSelector((state)=>state.app);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="user" element={<ProtectedRoute isAllowed={isUser(appState.me) && isStudent(appState.me)} />}>
        <Route index element={<UserHome />} />
        <Route path="application/create" element={<UserApplication />} />
        <Route path="application/list" element={<UserHistory />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default PageRouter;
